module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBudgetLow.7141762.webp";